/**
 * TanStack Router: /profile
 *
 * This route file was auto-generated by the route generation script.
 * Component: ProfilePage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import ProfilePage from '@/app/profile/page'

/**
 * Route: /profile
 * Layout: _auth (authenticated)
 * Component: ProfilePage
 */
export const Route = createFileRoute('/_auth/profile')({
  component: ProfilePage,
})
